// src/pages/organismos/JuradoElectoral.jsx

const titulares = [
  { cargo: "Presidente", nombre: "Javier López Machiavello", logia: "143" },
  { cargo: "Vice Presidente", nombre: "Jorge Mazzini Mendez", logia: "78" },
  { cargo: "Secretario", nombre: "José Vargas Riva", logia: "128" },
  { cargo: "Vocal de Lima/Callao", nombre: "Jaime Espinoza Montoya", logia: "131" },
  { cargo: "Vocal de Regiones", nombre: "Luis García Chocano", logia: "09" }
];

const suplentes = [
  { cargo: "Primer Vocal", nombre: "José Aramburú Barua", logia: "17" },
  { cargo: "Segundo Vocal", nombre: "Franklin Paz Cuadros", logia: "162" },
  { cargo: "Tercer Vocal", nombre: "Jhony Valeerio Roncagliolo", logia: "190" }
];

const JuradoElectoral = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-[#C5A059] selection:text-[#050505] font-sans pt-24 flex flex-col">
      
      {/* Hero Section */}
      <section className="relative w-full pt-32 pb-16 md:pt-40 md:pb-24 flex flex-col items-center justify-center overflow-hidden border-b border-white/5">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=2000&auto=format&fit=crop')" }} 
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-[#050505]/60 to-[#050505]"></div>

        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <p className="text-[#C5A059] tracking-[0.4em] uppercase text-xs md:text-sm font-light mb-4 animate-fade-in">
            Organismos Electorales
          </p>
          <h1 className="font-serif text-4xl md:text-6xl font-normal text-white tracking-tight animate-fade-in [animation-delay:0.3s] drop-shadow-lg mb-6">
            Jurado Electoral Autónomo
          </h1>
        </div>
      </section>

      {/* Contenido Principal: Dos Columnas */}
      <section className="relative z-20 max-w-[90rem] mx-auto px-6 lg:px-12 py-16 md:py-24 flex-grow w-full">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          
          {/* Columna Izquierda: Miembros */}
          <div className="lg:col-span-7 flex flex-col gap-12">
            
            {/* Miembros Titulares */}
            <div>
              <div className="mb-6 border-b border-white/10 pb-4 flex flex-col sm:flex-row justify-between sm:items-end gap-4">
                <h3 className="font-serif text-2xl md:text-3xl text-white">
                  Miembros Titulares
                </h3>
                <div className="text-left sm:text-right">
                  <p className="text-[#C5A059] text-[10px] tracking-widest uppercase border border-[#C5A059]/30 px-2 py-1 inline-block">
                    Decreto N° 142-046-GLP
                  </p>
                  <p className="text-gray-500 text-[10px] tracking-widest uppercase mt-2">
                    16 de Junio de 2024
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Presidente destacado ocupando 2 columnas en md */}
                <div className="md:col-span-2 bg-gradient-to-br from-[#0a0a0a] to-[#111111] border-t-2 border-[#C5A059] p-6 shadow-lg">
                  <span className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-3 font-semibold">{titulares[0].cargo}</span>
                  <p className="text-gray-500 text-[10px] tracking-widest uppercase mb-1">R.·. H.·.</p>
                  <h4 className="font-serif text-2xl text-white mb-2">{titulares[0].nombre}</h4>
                  <p className="text-gray-400 text-xs font-light tracking-wide">Logia N° {titulares[0].logia}</p>
                </div>
                
                {/* Resto de titulares */}
                {titulares.slice(1).map((miembro, idx) => (
                  <div key={idx} className="bg-[#0a0a0a] border border-white/5 p-6 hover:border-[#C5A059]/30 transition-colors">
                    <span className="text-gray-400 text-[10px] tracking-[0.2em] uppercase block mb-3 font-semibold">{miembro.cargo}</span>
                    <p className="text-gray-500 text-[10px] tracking-widest uppercase mb-1">R.·. H.·.</p>
                    <h4 className="font-serif text-xl text-white mb-2">{miembro.nombre}</h4>
                    <p className="text-gray-400 text-xs font-light tracking-wide">Logia N° {miembro.logia}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Miembros Suplentes */}
            <div>
              <div className="mb-6 border-b border-white/10 pb-4 flex flex-col sm:flex-row justify-between sm:items-end gap-4">
                <h3 className="font-serif text-2xl md:text-3xl text-gray-300">
                  Miembros Suplentes
                </h3>
                <div className="text-left sm:text-right">
                  <p className="text-gray-400 text-[10px] tracking-widest uppercase border border-gray-600 px-2 py-1 inline-block">
                    Decreto N° 142-046-GLP
                  </p>
                  <p className="text-gray-500 text-[10px] tracking-widest uppercase mt-2">
                    16 de Agosto de 2024
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {suplentes.map((miembro, idx) => (
                  <div key={idx} className="bg-[#050505] border border-white/5 p-6 hover:bg-white/[0.02] transition-colors">
                    <span className="text-gray-500 text-[10px] tracking-[0.2em] uppercase block mb-3 font-semibold">{miembro.cargo}</span>
                    <p className="text-gray-600 text-[10px] tracking-widest uppercase mb-1">R.·. H.·.</p>
                    <h4 className="font-serif text-lg text-gray-300 mb-2">{miembro.nombre}</h4>
                    <p className="text-gray-500 text-xs font-light tracking-wide">Logia N° {miembro.logia}</p>
                  </div>
                ))}
              </div>
            </div>

          </div>

          {/* Columna Derecha: Contacto y Atención */}
          <div className="lg:col-span-5">
            <div className="sticky top-32 flex flex-col gap-6">
              
              <div className="mb-2 border-b border-white/10 pb-4">
                <h3 className="font-serif text-2xl md:text-3xl text-white">
                  Contacto y Sedes
                </h3>
              </div>

              {/* Tarjeta de Contacto */}
              <div className="bg-gradient-to-br from-[#0a0a0a] to-[#111111] border border-[#C5A059]/20 p-8 shadow-xl">
                
                <div className="mb-8">
                  <span className="flex items-center gap-3 text-[#C5A059] text-xs tracking-[0.2em] uppercase mb-3">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    Dirección
                  </span>
                  <p className="text-gray-300 font-light text-sm md:text-base">
                    Av. José Gálvez Barrenechea N°599
                    <span className="block text-gray-500 text-xs mt-1">Urb Corpac, San Isidro</span>
                  </p>
                </div>

                <div className="mb-8">
                  <span className="flex items-center gap-3 text-[#C5A059] text-xs tracking-[0.2em] uppercase mb-3">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    Teléfonos
                  </span>
                  <div className="space-y-2">
                    <p className="text-gray-300 font-light text-sm md:text-base">
                      <span className="text-gray-500 mr-2 text-xs uppercase tracking-widest">Central:</span> 
                      618-5454 <span className="text-[#C5A059] mx-1">|</span> Anexo: 208
                    </p>
                    <p className="text-gray-300 font-light text-sm md:text-base">
                      <span className="text-gray-500 mr-2 text-xs uppercase tracking-widest">Directo:</span> 
                      618-5462
                    </p>
                  </div>
                </div>

                <div>
                  <span className="flex items-center gap-3 text-[#C5A059] text-xs tracking-[0.2em] uppercase mb-3">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    Correo Electrónico
                  </span>
                  <div className="flex flex-col gap-2">
                    <a href="mailto:jea@glperu.org.pe" className="text-gray-300 hover:text-[#C5A059] transition-colors font-light text-sm md:text-base">
                      jea@glperu.org.pe
                    </a>
                    <a href="mailto:jea_glp_peru@yahoo.es" className="text-gray-400 hover:text-[#C5A059] transition-colors font-light text-sm md:text-base">
                      jea_glp_peru@yahoo.es
                    </a>
                  </div>
                </div>

              </div>

              {/* Tarjeta de Horarios */}
              <div className="bg-[#0a0a0a] border border-white/5 p-8">
                <h4 className="text-white font-serif text-xl mb-6 flex items-center gap-3">
                  <svg className="w-5 h-5 text-[#C5A059]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Horarios de Atención
                </h4>
                
                <div className="space-y-6">
                  <div>
                    <span className="block text-gray-500 text-xs tracking-widest uppercase mb-1">Días de Atención</span>
                    <p className="text-gray-300 font-medium text-sm">De Lunes a Viernes</p>
                  </div>
                  
                  <div className="pl-4 border-l-2 border-white/10">
                    <span className="block text-[#C5A059] text-xs tracking-widest uppercase mb-1">Empleado de la GLP</span>
                    <p className="text-gray-300 font-light text-sm">De 15:00 a 22:00 Horas</p>
                  </div>

                  <div className="pl-4 border-l-2 border-[#C5A059]/50">
                    <span className="block text-[#C5A059] text-xs tracking-widest uppercase mb-1">Miembros del Jurado</span>
                    <p className="text-white font-medium text-sm">Martes de 19:30 a 22:00 Horas</p>
                  </div>
                </div>
              </div>

              <p className="text-center text-gray-600 text-[10px] tracking-widest uppercase mt-4">
                Actualizado el 22/09/2024
              </p>

            </div>
          </div>

        </div>
      </section>

    </div>
  );
};

export default JuradoElectoral;